const transliterateDictionary = {
  А: "a",
  Б: "b",
  В: "v",
  Г: "h",
  Д: "d",
  Е: "e",
  Ж: "zh",
  З: "z",
  И: "y",
  Й: "y",
  К: "k",
  Л: "l",
  М: "m",
  Н: "n",
  О: "o",
  П: "p",
  Р: "r",
  С: "s",
  Т: "t",
  У: "u",
  Ф: "f",
  Х: "kh",
  Ц: "ts",
  Ч: "ch",
  Ш: "sh",
  Щ: "shch",
  Ъ: "",
  Ы: "y",
  Ь: "",
  Э: "e",
  Ю: "yu",
  Я: "ya",
  а: "a",
  б: "b",
  в: "v",
  г: "h",
  д: "d",
  е: "e",
  ж: "zh",
  з: "z",
  и: "y",
  й: "y",
  к: "k",
  л: "l",
  м: "m",
  н: "n",
  о: "o",
  п: "p",
  р: "r",
  с: "s",
  т: "t",
  у: "u",
  ф: "f",
  х: "kh",
  ц: "ts",
  ч: "ch",
  ш: "sh",
  щ: "shch",
  ъ: "y",
  ы: "y",
  ь: "",
  э: "e",
  ю: "yu",
  я: "ya",
  Є: "ye",
  є: "ye",
  Ї: "yi",
  ї: "yi",
  І: "i",
  і: "i",
  Ґ: "g",
  ґ: "g",
  ".": "",
  "’": "'",
  " ": "_",
  ",": "_",
  "/": "_",
};

const transliteratedIdDictionary = {
  а: "a",
  б: "b",
  "б’я": "b,ya",
  ба: "ba",
  бе: "be",
  би: "by",
  бі1: "bi1",
  бі: "bi",
  бо: "bo",
  бу: "bu",
  в: "v",
  "в’ї": "v,yi",
  "в’я": "v,ya",
  ва1: "va1",
  ва: "va",
  ве: "ve",
  ви: "vy",
  ві: "vi",
  во: "vo",
  ву: "vu",
  г: "h",
  га: "ha",
  ги: "hy",
  гі: "hi",
  го: "ho",
  гу: "hu",
  д: "d",
  да: "da",
  де: "de",
  ди1: "dy1",
  ди: "dy",
  ді1: "di1",
  ді: "di",
  до: "do",
  ду1: "du1",
  ду: "du",
  дя: "dya",
  дь: "d'",
  є: "ye",
  ж: "zh",
  жа: "zha",
  же: "zhe",
  жи: "zhy",
  жі: "zhi",
  жо: "zho",
  жу: "zhu",
  з: "z",
  "з’ї": "z,yi",
  за: "za",
  зе: "ze",
  зи: "zy",
  зо: "zo",
  зу: "zu",
  зь: "z'",
  зьо: "zyo",
  й: "y",
  і: "i",
  ї1: "yi1",
  ї: "yi",
  к: "k",
  ка: "ka",
  ке: "ke",
  ки1: "ky1",
  ки: "ky",
  кі: "ki",
  кі1: "ki1",
  ко: "ko",
  ку: "ku",
  л: "l",
  ла: "la",
  ле: "le",
  ли: "ly",
  лі: "li",
  ло: "lo",
  лу: "lu",
  лю: "lyu",
  ля: "lya",
  ль: "l'",
  льо: "lyo",
  м: "m",
  "м’я": "m,ya",
  ма: "ma",
  ме: "me",
  ми: "my",
  мі: "mi",
  мо: "mo",
  му: "mu",
  му1: "mu1",
  н: "n",
  на: "na",
  ни: "ny",
  ні1: "ni1",
  ні: "ni",
  но: "no",
  ня: "nya",
  нь: "n'",
  о1: "o1",
  о: "o",
  п: "p",
  "п’є": "p,ye",
  "п’ю": "p,yu",
  "п’я": "p,ya",
  па: "pa",
  пе: "pe",
  пи: "py",
  пі: "pi",
  по: "po",
  пу: "pu",
  р: "r",
  "р’ї": "r,yi",
  "р’я": "r,ya",
  ра: "ra",
  ре: "re",
  ри: "ry",
  ри1: "ry1",
  рі: "ri",
  ро: "ro",
  ру: "ru",
  рю: "ryu",
  ря: "rya",
  с: "s",
  са: "sa",
  се: "se",
  си: "sy",
  си1: "sy1",
  сі: "si",
  сі1: "si1",
  со: "so",
  су: "su",
  ся: "sya",
  сь: "s'",
  т: "t",
  та: "ta",
  те: "te",
  ти: "ty",
  ті: "ti",
  то: "to",
  ту: "tu",
  тю: "tyu",
  ть: "t'",
  у: "u",
  ф: "f",
  фа: "fa",
  фе: "fe",
  фо: "fo",
  х: "kh",
  ха: "kha",
  хи: "khy",
  хо: "kho",
  ху: "khu",
  ц: "ts",
  ца: "tsa",
  це: "tse",
  ци: "tsy",
  ці: "tsi",
  ця: "tsya",
  ць: "ts'",
  цьо: "tsyo",
  ч: "ch",
  ча1: "cha1",
  ча: "cha",
  че1: "che1",
  че: "che",
  чи: "chy",
  чі: "chi",
  чо: "cho",
  ш: "sh",
  "ш’ю": "sh,yu",
  ша1: "sha1",
  ша: "sha",
  ши: "shy",
  шо: "sho",
  шу: "shu",
  щ: "shch",
  щи: "shchy",
  щі: "shchi",
  щу: "shchu",
  я: "ya",
  А: "a",
  Б: "b",
  В: "v",
  Г: "h",
  Д: "d",
  Є: "ye",
  Ж: "zh",
  З: "z",
  Й: "y",
  І: "i",
  Ї: "yi",
  К: "k",
  Л: "l",
  М: "m",
  Н: "n",
  О: "o",
  П: "p",
  Р: "r",
  С: "s",
  Т: "t",
  У: "u",
  Ф: "f",
  Х: "kh",
  Ц: "ts",
  Ч: "ch",
  Ш: "sh",
  Щ: "shch",
  Я: "ya",
  БА: "ba",
  БЕ: "be",
  БИ: "by",
  БІ: "bi",
  БО: "bo",
  БУ: "bu",
  ВА: "va",
  ВЕ: "ve",
  ВИ: "vy",
  ВІ: "vi",
  ВО: "vo",
  ВУ: "vu",
  ГА: "ha",
  ГИ: "hy",
  ГІ: "hi",
  ГО: "ho",
  ГУ: "hu",
  ДА: "da",
  ДЕ: "de",
  ДИ: "dy",
  ДІ: "di",
  ДО: "do",
  ДУ: "du",
  ДЯ: "dya",
  ДЬ: "d'",
  ЖА: "zha",
  ЖЕ: "zhe",
  ЖИ: "zhy",
  ЖІ: "zhi",
  ЖО: "zho",
  ЖУ: "zhu",
  ЗА: "za",
  ЗЕ: "ze",
  ЗИ: "zy",
  ЗО: "zo",
  ЗУ: "zu",
  ЗЬ: "z'",
  КА: "ka",
  КЕ: "ke",
  КИ: "ky",
  КІ: "ki",
  КО: "ko",
  КУ: "ku",
  ЛА: "la",
  ЛЕ: "le",
  ЛИ: "ly",
  ЛІ: "li",
  ЛО: "lo",
  ЛУ: "lu",
  ЛЮ: "lyu",
  ЛЯ: "lya",
  ЛЬ: "l'",
  МА: "ma",
  МЕ: "me",
  МИ: "my",
  МІ: "mi",
  МО: "mo",
  МУ: "mu",
  НА: "na",
  НИ: "ny",
  НІ: "ni",
  НО: "no",
  НЯ: "nya",
  НЬ: "n'",
  ПА: "pa",
  ПЕ: "pe",
  ПИ: "py",
  ПІ: "pi",
  ПО: "po",
  ПУ: "pu",
  РА: "ra",
  РЕ: "re",
  РИ: "ry",
  РИ1: "ry1",
  РІ: "ri",
  РО: "ro",
  РУ: "ru",
  РЮ: "ryu",
  РЯ: "rya",
  СА: "sa",
  СЕ: "se",
  СИ: "sy",
  СИ1: "sy1",
  СІ: "si",
  СІ1: "si1",
  СО: "so",
  СУ: "su",
  СЯ: "sya",
  СЬ: "s'",
  ТА: "ta",
  ТЕ: "te",
  ТИ: "ty",
  ТІ: "ti",
  ТО: "to",
  ТУ: "tu",
  ТЮ: "tyu",
  ТЬ: "t'",
  ФА: "fa",
  ФЕ: "fe",
  ФО: "fo",
  ХА: "kha",
  ХИ: "khy",
  ХО: "kho",
  ХУ: "khu",
  ЦА: "tsa",
  ЦЕ: "tse",
  ЦИ: "tsy",
  ЦІ: "tsi",
  ЦЯ: "tsya",
  ЦЬ: "ts'",
  ЧА: "cha",
  ЧЕ: "che",
  ЧИ: "chy",
  ЧІ: "chi",
  ЧО: "cho",
  ША: "sha",
  ШИ: "shy",
  ШО: "sho",
  ШУ: "shu",
  ЩИ: "shchy",
  ЩІ: "shchi",
  ЩУ: "shchu",
  "Б’Я": "b,ya",
  "В’Ї": "v,yi",
  "В’Я": "v,ya",
  "З’Ї": "z,yi",
  ЗЬО: "zyo",
  ЛЬО: "lyo",
  "М’Я": "m,ya",
  "П’Є": "p,ye",
  "П’Ю": "p,yu",
  "П’Я": "p,ya",
  "Р’Ї": "r,yi",
  "Р’Я": "ts'",
  ЦЬО: "tsyo",
  "Ш’Ю": "sh,yu",
  "*": "",
};

const wordBySyllableDictionary = {
  "*": "",
  а: "ангел",
  б: "Б",
  "б’я": "Б’Я",
  ба: "бантик",
  бе: "беркут",
  би: "бик",
  бі1: "білка",
  бі: "біг",
  бо: "борщ",
  бу: "бублик",
  в: "В",
  "в’ї": "В’Ї",
  "в’я": "В’Я",
  "в’є": "В’Є",
  ва1: "ваза",
  ва: "вафля",
  ве: "вежа",
  ви: "вишня",
  ві: "віник",
  во: "вовк",
  ву: "вузол",
  г: "Г",
  га: "гайка",
  ги: "гиря",
  гі: "гілка",
  го: "голка",
  гу: "губи",
  д: "Д",
  да: "дах",
  де: "дерево",
  ди1: "диня",
  ди: "дим",
  ді1: "дірка",
  ді: "дівчинка",
  до: "дошка",
  ду1: "душ",
  ду: "дудка",
  дя: "дятел",
  дь: "ДЬ",
  є: "єнот",
  ж: "Ж",
  жа: "жабка",
  же: "жезл",
  жи: "жито",
  жі: "жінка",
  жо: "жолудь",
  жу: "жуйка",
  з: "З",
  "з’ї": "З’Ї",
  за: "заєць",
  зе: "зебра",
  зі: "зірка",
  зи: "зимородок",
  зо: "зошит",
  зу: "зуби",
  зь: "ЗЬ",
  зьо: "ЗЬО",
  й: "Й",
  і: "іграшки",
  ї1: "їжак",
  ї: "їжа",
  к: "К",
  ка: "кактус",
  ке: "кекс",
  ке1: "келих",
  ки1: "кит",
  ки: "килим",
  кі: "ківі",
  кі1: "кіготь",
  ко: "кошик",
  ку: "кубик",
  л: "Л",
  ла: "лава",
  ле: "лезо",
  ли: "листя",
  лі: "лійка",
  ло: "ложка",
  лу: "лупа",
  лю: "люстра",
  ля: "лялька",
  ль: "ЛЬ",
  льо: "ЛЬО",
  м: "М",
  "м’я": "М’Я",
  ма: "маска",
  ме: "мед",
  ми: "миша",
  мі: "місяць",
  мо: "морква",
  // TODO: мушля vs муха
  му: "муха",
  му1: "мушля",
  н: "Н",
  на: "напій",
  ни: "нитки",
  ні1: "ніготь",
  ні: "ніж",
  но: "ножиці",
  ня: "няня",
  нь: "НЬ",
  ньо: "НЬО",
  о1: "олень",
  о: "око",
  п: "П",
  "п’є": "П’Є",
  "п’ю": "П’Ю",
  "п’я": "П’Я",
  па: "палець",
  пе: "печиво",
  пи: "писанка",
  пі: "півень",
  по: "поїзд",
  пу: "пудель",
  р: "Р",
  "р’ї": "Р’Ї",
  "р’є": "Р’Є",
  "р’я": "Р’Я",
  ра: "рак",
  ре: "ремінь",
  ри: "рис",
  ри1: "риба",
  рі: "ріг",
  ро: "робот",
  ру: "ручка",
  рю: "рюмка",
  ря: "ряска",
  с: "С",
  са: "сани",
  се: "серце",
  // TODO: сито vs сир у картинках та звуках, оскільки сир є у загадках
  си: "сир",
  си1: "сич",
  сі: "сіно",
  сі1: "сік",
  со: "сонце",
  су: "сумка",
  сьо: "СЬО",
  ся: "сяйво",
  сь: "СЬ",
  т: "Т",
  та: "танк",
  те: "терка",
  ти: "тигр",
  ті: "тісто",
  то: "торт",
  ту: "туфлі",
  /*тукан тумба тур туз туфля туш*/ тю: "тюбик",
  ть: "ТЬ",
  у: "учень",
  ф: "Ф",
  фа: "фарба",
  фі: "фільм",
  фе: "фея",
  фо: "фокусник",
  х: "Х",
  ха: "хата",
  хи: "хижка",
  хо: "хобот",
  ху: "хустка",
  ц: "Ц",
  ца: "цап",
  це: "цегла",
  ци: "цифри",
  ці: "ціль",
  цу: "цуцик",
  ця: "цятка",
  ць: "ЦЬ",
  цьо: "ЦЬО",
  ч: "Ч",
  ча: "чашка",
  ча1: "чайка",
  че1: "чешки",
  че: "череп",
  чи: "чиж",
  чі: "чіпси",
  чо: "човен",
  чу: "чуб",
  ш: "Ш",
  "ш’ю": "Ш’Ю",
  ша1: "шабля",
  ша: "шапка",
  ше: "шершень",
  ші: "шість",
  ши: "шишка",
  шо: "шорти",
  шу: "шуба",
  щ: "Щ",
  ща: "щастя",
  щи: "щит",
  щі: "щітка",
  щу: "щука",
  я: "яблуко",
  А: "А",
  Б: "Б",
  В: "В",
  Г: "Г",
  Ґ: "Ґ",
  Д: "Д",
  Є: "Є",
  Ж: "Ж",
  З: "З",
  Й: "Й",
  І: "І",
  Ї: "Ї",
  К: "К",
  Л: "Л",
  М: "М",
  Н: "Н",
  О: "О",
  П: "П",
  Р: "Р",
  С: "С",
  Т: "Т",
  У: "У",
  Ф: "Ф",
  Х: "Х",
  Ц: "Ц",
  Ч: "Ч",
  Ш: "Ш",
  Щ: "Щ",
  Я: "Я",
  БА: "БА",
  БЕ: "БЕ",
  БИ: "БИ",
  БІ: "БІ",
  БО: "БО",
  БУ: "БУ",
  ВА: "ВА",
  ВЕ: "ВЕ",
  ВИ: "ВИ",
  ВІ: "ВІ",
  ВО: "ВО",
  ВУ: "ВУ",
  ГА: "ГА",
  ГИ: "ГИ",
  ГІ: "ГІ",
  ГО: "ГО",
  ГУ: "ГУ",
  ДА: "ДА",
  ДЕ: "ДЕ",
  ДИ: "ДИ",
  ДІ: "ДІ",
  ДО: "ДО",
  ДУ: "ДУ",
  ДЯ: "ДЯ",
  ДЬ: "ДЬ",
  ЖА: "ЖА",
  ЖЕ: "ЖЕ",
  ЖИ: "ЖИ",
  ЖІ: "ЖІ",
  ЖО: "ЖО",
  ЖУ: "ЖУ",
  ЗА: "ЗА",
  ЗЕ: "ЗЕ",
  ЗІ: "ЗІ",
  ЗИ: "ЗИ",
  ЗО: "ЗО",
  ЗУ: "ЗУ",
  ЗЬ: "ЗЬ",
  КА: "КА",
  КЕ: "КЕ",
  КИ: "КИ",
  КІ: "КІ",
  КО: "КО",
  КУ: "КУ",
  ЛА: "ЛА",
  ЛЕ: "ЛЕ",
  ЛИ: "ЛИ",
  ЛІ: "ЛІ",
  ЛО: "ЛО",
  ЛУ: "ЛУ",
  ЛЮ: "ЛЮ",
  ЛЯ: "ЛЯ",
  ЛЬ: "ЛЬ",
  МА: "МА",
  МЕ: "МЕ",
  МИ: "МИ",
  МІ: "МІ",
  МО: "МО",
  МУ: "МУ",
  НА: "НА",
  НИ: "НИ",
  НІ: "НІ",
  НО: "НО",
  НЯ: "НЯ",
  НЬ: "НЬ",
  ПА: "ПА",
  ПЕ: "ПЕ",
  ПИ: "ПИ",
  ПІ: "ПІ",
  ПО: "ПО",
  ПУ: "ПУ",
  РА: "РА",
  РЕ: "РЕ",
  РИ: "РИ",
  РІ: "РІ",
  РО: "РО",
  РУ: "РУ",
  РЮ: "РЮ",
  РЯ: "РЯ",
  СА: "СА",
  СЕ: "СЕ",
  СИ: "СИ",
  СІ: "СІ",
  СІ1: "СІ1",
  СО: "СО",
  СУ: "СУ",
  СЯ: "СЯ",
  СЬ: "СЬ",
  ТА: "ТА",
  ТЕ: "ТЕ",
  ТИ: "ТИ",
  ТІ: "ТІ",
  ТО: "ТО",
  ТУ: "ТУ",
  ТЮ: "ТЮ",
  ТЬ: "ТЬ",
  ФА: "ФА",
  ФЕ: "ФЕ",
  ФІ: "ФІ",
  ФО: "ФО",
  ХА: "ХА",
  ХИ: "ХИ",
  ХО: "ХО",
  ХУ: "ХУ",
  ЦА: "ЦА",
  ЦЕ: "ЦЕ",
  ЦИ: "ЦИ",
  ЦІ: "ЦІ",
  ЦУ: "ЦУ",
  ЦЯ: "ЦЯ",
  ЦЬ: "ЦЬ",
  ЧА: "ЧА",
  ЧЕ: "ЧЕ",
  ЧИ: "ЧИ",
  ЧІ: "ЧІ",
  ЧО: "ЧО",
  ЧУ: "ЧУ",
  ША: "ША",
  ШЕ: "ШЕ",
  ШИ: "ШИ",
  ШО: "ШО",
  ШІ: "ШІ",
  ШУ: "ШУ",
  ЩА: "ЩА",
  ЩИ: "ЩИ",
  ЩІ: "ЩІ",
  ЩУ: "ЩУ",
  "Б’Я": "Б’Я",
  "В’Ї": "В’Ї",
  "В’Є": "В’Є",
  "В’Я": "В’Я",
  "З’Ї": "З’Ї",
  ЗЬО: "ЗЬО",
  ЛЬО: "ЛЬО",
  СЬО: "СЬО",
  "М’Я": "М’Я",
  "П’Є": "П’Є",
  "П’Ю": "П’Ю",
  "П’Я": "П’Я",
  "Р’Є": "Р’Є",
  "Р’Ї": "Р’Ї",
  "Р’Я": "Р’Я",
  ЦЬО: "ЦЬО",
  НЬО: "НЬО",
  "Ш’Ю": "Ш’Ю",
};

const quizAnswersArray = [
  "абетка",
  "акула",
  "акули",
  "ананас",
  "ананаси",
  "бабаки",
  "бабуся",
  "банани",
  "банка",
  "барабан",
  "барабани",
  "барани",
  "батарея",
  "батько",
  "берег",
  "береги",
  "бивень",
  "бивні",
  "біг",
  "бігуни",
  "білочка",
  "білченя",
  "блоха",
  "бобри",
  "богомол",
  "богомоли",
  "болото",
  "борода",
  "боротьба",
  "брови",
  "будинки",
  "букети",
  "булава",
  "бур’яни",
  "буряки",
  "вагон",
  "вагони",
  "ваза",
  "валіза",
  "варани",
  "васильок",
  "вафлі",
  "ведмеді",
  "ведмідь",
  "велетень",
  "велетні",
  "весла",
  "вибух",
  "вибухи",
  "виделка",
  "вишні",
  "відро",
  "віз",
  "візки",
  "вісім",
  "віяло",
  "вогні",
  "вогонь",
  "водій",
  "водії",
  "водопій",
  "ворота",
  "вуж",
  "вулики",
  "газ",
  "газети",
  "гайка",
  "галушки",
  "гараж",
  "гаражі",
  "гарбуз",
  "гарбузи",
  "гачки",
  "гієна",
  "гілки",
  "гітара",
  "гітари",
  "глина",
  "гноми",
  "гномик",
  "голова",
  "голуб’я",
  "гора",
  "гори",
  "горила",
  "горіх",
  "горіхи",
  "горошина",
  "груша",
  "гусь",
  "два",
  "двері",
  "дев’ять",
  "дзьоби",
  "димарі",
  "динька",
  "дитина",
  "дівчина",
  "дідусі",
  "дідусь",
  "долоні",
  "долоня",
  "доміно",
  "дорога",
  "дороги",
  "дощ",
  "дощі",
  "дрова",
  "дуб",
  "дудка",
  "духовка",
  "душ",
  "дядько",
  "єдинороги",
  "жало",
  "жереб’я",
  "жирафа",
  "жито",
  "жолуді",
  "жолудь",
  "жук",
  "жуки",
  "заводи",
  "залізо",
  "замки",
  "заноза",
  "зарості",
  "земля",
  "зернята",
  "злива",
  "змія",
  "зозуля",
  "зорі",
  "зуб",
  "ібіси",
  "ігуана",
  "їжа",
  "їжаченя",
  "ікла",
  "ікона",
  "індик",
  "індики",
  "іній",
  "кавуни",
  "кажан",
  "кажани",
  "какаду",
  "калина",
  "калюжа",
  "канапа",
  "капелюх",
  "капелюхи",
  "капець",
  "капуста",
  "капці",
  "карта",
  "каченя",
  "каша",
  "квитки",
  "квиток",
  "кеглі",
  "кеди",
  "кенгуру",
  "кеш’ю",
  "килим",
  "килими",
  "кити",
  "киця",
  "ківі",
  "кіготь",
  "кінь",
  "книга",
  "коала",
  "коали",
  "кобра",
  "ковалі",
  "коваль",
  "ковзани",
  "коза",
  "козак",
  "козаки",
  "козеня",
  "кози",
  "кокос",
  "кокоси",
  "колесо",
  "колібрі",
  "колії",
  "колія",
  "коло",
  "колода",
  "колони",
  "колос",
  "кольори",
  "комар",
  "коники",
  "коні",
  "копито",
  "корал",
  "корали",
  "коробка",
  "корова",
  "корови",
  "корона",
  "коса",
  "косуля",
  "кофта",
  "кран",
  "крем",
  "крила",
  "кролик",
  "кролики",
  "кулаки",
  "куля",
  "кульбаба",
  "кулька",
  "кульок",
  "куниця",
  "курага",
  "кури",
  "кухарі",
  "кущ",
  "лаваш",
  "лампа",
  "ласощі",
  "лби",
  "лебеді",
  "лебідь",
  "лев",
  "левеня",
  "левиця",
  "лелека",
  "лелеки",
  "лижі",
  "лимон",
  "лимонад",
  "лимони",
  "лисеня",
  "лисиця",
  "лицарі",
  "ліани",
  "ліжко",
  "лікарі",
  "лісовоз",
  "літаки",
  "лобзик",
  "лопата",
  "лопати",
  "лось",
  "люди",
  "льодяник",
  "льон",
  "м’ясо",
  "мавпа",
  "макака",
  "макаки",
  "малина",
  "малюнки",
  "малята",
  "мама",
  "машина",
  "медуза",
  "медузи",
  "мелодія",
  "меч",
  "поліція",
  "місяць",
  "молодець",
  "молоко",
  "молотки",
  "молоток",
  "монітор",
  "море",
  "моряки",
  "мотори",
  "мох",
  "музей",
  "музеї",
  "мурашка",
  "намети",
  "намисто",
  "насінина",
  "насінини",
  "нігті",
  "ніж",
  "носоріг",
  "носороги",
  "ноти",
  "оаза",
  "овал",
  "овали",
  "овечка",
  "овоч",
  "овочі",
  "одяг",
  "ожина",
  "озеро",
  "око",
  "окуляри",
  "олені",
  "олень",
  "оси",
  "осінь",
  "очі",
  "п’явка",
  "п’яточок",
  "п’ять",
  "павич",
  "павичі",
  "павуки",
  "пазурі",
  "пакети",
  "палац",
  "палаци",
  "паляниця",
  "пальма",
  "пальто",
  "панама",
  "папуга",
  "папужка",
  "парасоля",
  "перець",
  "печиво",
  "пила",
  "пили",
  "піаніно",
  "піжама",
  "пікнік",
  "піна",
  "пір’їна",
  "пір’я",
  "піраміда",
  "пітони",
  "піца",
  "піч",
  "плече",
  "пов’язка",
  "погода",
  "пожежа",
  "полуниця",
  "поля",
  "порося",
  "посуд",
  "пряжа",
  "пси",
  "пух",
  "ракета",
  "ракети",
  "ракетка",
  "редька",
  "рейки",
  "ремінь",
  "реп’яхи",
  "риба",
  "рисі",
  "рись",
  "різьба",
  "ріпка",
  "роги",
  "родина",
  "розмова",
  "ромашки",
  "рот",
  "рукавиця",
  "рюкзак",
  "сад",
  "самокат",
  "самокати",
  "сані",
  "селезень",
  "селезні",
  "селяни",
  "силач",
  "синиця",
  "сир",
  "сіль",
  "сім",
  "сіно",
  "слива",
  "слон",
  "сльоза",
  "собака",
  "собаки",
  "сова",
  "сови",
  "соки",
  "сокіл",
  "солдат",
  "солдати",
  "солов’ї",
  "соловей",
  "сонях",
  "соняхи",
  "сорока",
  "соска",
  "стіл",
  "столи",
  "сукня",
  "сумка",
  "суп",
  "сутичка",
  "тато",
  "тачка",
  "телефони",
  "тетерев",
  "тінь",
  "томати",
  "трава",
  "труба",
  "тумба",
  "туфелька",
  "тюль",
  "удав",
  "удави",
  "уроки",
  "факел",
  "фермер",
  "фляги",
  "фольга",
  "хвиля",
  "хижаки",
  "хліб",
  "хлібина",
  "хлоп’я",
  "хмара",
  "ховрах",
  "ховрахи",
  "хор",
  "хутро",
  "цап",
  "цвіт",
  "цибулина",
  "цибуля",
  "цитрус",
  "цьом",
  "чаєня",
  "чай",
  "чайник",
  "чайники",
  "чапля",
  "чародії",
  "чашка",
  "черв’яки",
  "черевики",
  "череп",
  "черепаха",
  "черепи",
  "чиж",
  "чобітки",
  "чоботи",
  "човен",
  "чотири",
  "шаблі",
  "шапка",
  "шарф",
  "шахи",
  "шви",
  "шило",
  "шина",
  "шов",
  "шоколад",
  "шолом",
  "шпага",
  "штора",
  "шум",
  "шухляда",
  "щиголь",
  "щука",
  "щур",
  "ябеда",
  "яблука",
  "яйце",
  "ялина",
  "ялини",
  "яма",
  "ящірка",
];

const vowelArray = [
  "а",
  "е",
  "и",
  "і",
  "о",
  "у",
  "ї",
  "є",
  "ю",
  "я",
  "й",
  "ы",
  "э",
  "А",
  "Е",
  "И",
  "І",
  "О",
  "У",
  "Ї",
  "Є",
  "Ю",
  "Я",
  "Ы",
  "Э",
  "Й",
];

const consonantArray = [
  "б",
  "в",
  "г",
  "ґ",
  "д",
  "ж",
  "з",
  "й",
  "к",
  "л",
  "м",
  "н",
  "п",
  "р",
  "с",
  "т",
  "ф",
  "х",
  "ц",
  "ч",
  "ш",
  "щ",
  "ъ",
  "Б",
  "В",
  "Г",
  "Ґ",
  "Д",
  "Ж",
  "З",
  "Й",
  "К",
  "Л",
  "М",
  "Н",
  "П",
  "Р",
  "С",
  "Т",
  "Ф",
  "Х",
  "Ц",
  "Ч",
  "Ш",
  "Щ",
  "Ъ",
  "з’ї",
  "м’я",
  "р’я",
  "п’є",
  "п’ю",
  "п’я",
  "р’ї",
  "б’я",
  "в’ї",
  "в’я",
  "ш’ю",
  "льо",
  "сьо",
  "цьо",
  "зьо",
  "ль",
  "нь",
  "дь",
  "ть",
  "зь",
  "сь",
  "ць",
  "—",
  "-",
  "!",
  ",",
  ":",
  "»",
  "«",
  ")",
  "(",
  "?",
];

export {
  transliterateDictionary,
  transliteratedIdDictionary,
  wordBySyllableDictionary,
  quizAnswersArray,
  vowelArray,
  consonantArray,
};
